module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("Copyright © 2010 by Thomas H. Cook")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _vm._v(" "), _c('br'), _vm._v("Cook, Thomas H.\n"), _c('br'), _vm._v("The last talk with Lola Faye / Thomas H. Cook.\n"), _c('br'), _vm._v("p. cm.\n"), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-15-101407-1\n"), _c('br'), _vm._v("1. Murder victims’ families—Fiction. 2. Crimes of passion—Fiction. 3. Psychological fiction. I. Title.\n"), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PS")]), _vm._v("3553.055465"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("L")]), _vm._v("37 2010\n"), _c('br'), _vm._v("813'.54—dc22 2009027927")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-54127-3")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("v2.1116")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0